module.exports = __webpack_public_path__ + "media/images/amenities_icons/accomodation-2b5bc3fa0c30c2fc2f3bad0925c31c6d.svg";